module.exports = (__parcel__import__("3oRkC")).then(() => parcelRequire('g36Vt'));